import { createApp } from 'vue'
import '@babel/polyfill'
import 'core-js/es/promise'
import 'core-js/es/string'
import 'core-js/es/array'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import vuetify from '@/plugins/vuetify'
import axios from '@/plugins/axios'
import mochub from '@/plugins/mochub'
import AuthService from './services/auth.service'
import DateFilter from './filters/date'
import DateTimeFilter from './filters/dateTime'
import _ from 'lodash'

const authService = new AuthService()
const app = createApp(App)

app.config.globalProperties.$authService = authService
app.config.globalProperties.$filters = { DateFilter, DateTimeFilter }
app.config.globalProperties.$_= _

app.use(router).use(store).use(axios)
app.use(mochub)
app.use(vuetify)

i18n(app).mount('#app')

const globals = app.config.globalProperties
export { globals }
